import { getCsrfToken } from '../utils/csrfUtils'
import { Config } from '../utils/config'
import { authErrorAction, authSuccessAction } from '.'

const authRequest = async (dispatch, username, password) => {
  try {
    const csrfToken = await getCsrfToken()

    const response = await fetch(`${Config.BASE_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': csrfToken
      },
      body: JSON.stringify({ username, password }),
      credentials: 'include'
    })

    if (response.ok) {
      const data = await response.json()
      dispatch(authSuccessAction())
      return data
    } else {
      const errorData = await response.json()
      if (errorData.details && errorData.details.length > 0) {
        throw new Error(errorData.details[0].message)
      } else {
        throw new Error(errorData.error || 'Authentication failed')
      }
    }
  } catch (error) {
    if (error.message === 'Failed to fetch') {
      throw new Error('Server offline. Please try again later.')
    }

    dispatch(authErrorAction())
    throw error
  }
}

const checkAuth = async (dispatch) => {
  const csrfToken = await getCsrfToken()

  const response = await fetch(`${Config.BASE_URL}/whoami`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-csrf-token': csrfToken
    },
    credentials: 'include'
  })

  if (response.ok) {
    dispatch(authSuccessAction())
  } else {
    dispatch(authErrorAction())
  }
}

export { authRequest, checkAuth }
